module.exports = __webpack_public_path__ + "fonts/siemens-sans-bold.woff";